import {
  JADWALS_GET,
  JADWAL_JENJANGS_GET,
  JADWAL_YEARS_GET,
  JADWAL_SEMS_GET,
  JADWAL_KELASS_GET,
  JADWAL_PELAJARANS_GET,
  JADWAL_GURUS_GET,
  JADWAL_ADD,
  JADWAL_EDIT,
  JADWAL_GET,
  JADWAL_SETTING_EDIT,
  JADWAL_DELETE,
  JADWAL_SAVE_EVENTS,
  JADWAL_CLASH_TEACHERS,
} from './reduxConstant';

export const jadwalsGet = (jadwals) => {
  return {
    type: JADWALS_GET,
    payload: {
      jadwals,
    },
  };
};

export const jadwalJenjangsGet = (jenjangs) => {
  return {
    type: JADWAL_JENJANGS_GET,
    payload: {
      jenjangs,
    },
  };
};

export const jadwalYearsGet = (years) => {
  return {
    type: JADWAL_YEARS_GET,
    payload: {
      years,
    },
  };
};

export const jadwalSemsGet = (sems) => {
  return {
    type: JADWAL_SEMS_GET,
    payload: {
      sems,
    },
  };
};

export const jadwalKelassGet = (kelass) => {
  return {
    type: JADWAL_KELASS_GET,
    payload: {
      kelass,
    },
  };
};

export const jadwalPelajaransGet = (pelajarans) => {
  return {
    type: JADWAL_PELAJARANS_GET,
    payload: {
      pelajarans,
    },
  };
};

export const jadwalGurusGet = (gurus) => {
  return {
    type: JADWAL_GURUS_GET,
    payload: {
      gurus,
    },
  };
};

export const jadwalAdd = (jadwal) => {
  return {
    type: JADWAL_ADD,
    payload: {
      jadwal,
    },
  };
};

export const jadwalEdit = (jadwal) => {
  return {
    type: JADWAL_EDIT,
    payload: {
      jadwal,
    },
  };
};

export const jadwalGet = (jadwal) => {
  return {
    type: JADWAL_GET,
    payload: {
      jadwal,
    },
  };
};

export const jadwalSettingEdit = (jadwalSetting) => {
  return {
    type: JADWAL_SETTING_EDIT,
    payload: {
      jadwalSetting,
    },
  };
};

export const jadwalDelete = (jadwal) => {
  return {
    type: JADWAL_DELETE,
    payload: {
      jadwal,
    },
  };
};

export const jadwalSaveEvents = (events) => {
  return {
    type: JADWAL_SAVE_EVENTS,
    payload: {
      events
    },
  };
};

export const jadwalClashTeachers = (clashTeachers) => {
  return {
    type: JADWAL_CLASH_TEACHERS,
    payload: {
      clashTeachers
    },
  };
};
